import { getContractList } from '@/api/rights/contract';
import type { ContractItem } from './types';
import { processDetails } from './utils';

type ContractServiceType = {
  sceneCache: Map<string, ContractItem[]>;
  loadContracts: (scene: string, rightsModelType?: number) => Promise<ContractItem[] | undefined>;
};

export const ContractService = ():ContractServiceType => {
  /** 场景缓存Map，用于存储已获取的合同场景数据 */
  const sceneCache: Map<string, ContractItem[]> = new Map();

  // 数据层
  const fetcher = {
    getList: (
      scene: string,
      rightsModelType?: number,
    ) => getContractList({ scene, rightsModelType }),
  };

  // 缓存层
  const cache = {
    get: (scene: string) => sceneCache.get(scene),
    set: (scene: string, data: ContractItem[]) => sceneCache.set(scene, data),
  };

  // 业务组合
  const loadContracts = async (scene: string, rightsModelType?: number) => {
    if (cache.get(scene)) {
      return cache.get(scene);
    }

    const list = await fetcher.getList(scene, rightsModelType);
    const details = list.map(
      (item) => processDetails(item),
    );

    cache.set(scene, details);
    return cache.get(scene);
  };

  return {
    sceneCache,
    loadContracts,
  };
};
